import { render, staticRenderFns } from "./pageConfiguration.vue?vue&type=template&id=4c487434&scoped=true&"
import script from "./pageConfiguration.vue?vue&type=script&lang=js&"
export * from "./pageConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./pageConfiguration.vue?vue&type=style&index=0&id=4c487434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c487434",
  null
  
)

export default component.exports